import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "media-left image is-96x96" }
const _hoisted_2 = { class: "image is-hidden-mobile" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "media-content" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "has-text-weight-bold",
  style: {"background-color":"#f69522","color":"#ffffff"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { class: "media-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("figure", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.listing._source.image
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("small", {
        class: _normalizeClass(["has-text-weight-bold py-1", { 'has-text-primary': _ctx.isDark, 'has-text-info': !_ctx.isDark }])
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.listing._source.type_id), 1)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", {
          class: _normalizeClass({ 'has-text-white': _ctx.isDark })
        }, [
          _createElementVNode("strong", {
            class: _normalizeClass({ 'has-text-white': _ctx.isDark })
          }, _toDisplayString(_ctx.listing._source.name) + " [" + _toDisplayString(_ctx.listing._source.sku) + "] ", 3),
          _hoisted_6,
          _createTextVNode(" R " + _toDisplayString(_ctx.listing._source.price), 1),
          (_ctx.listing._source.is_special)
            ? (_openBlock(), _createElementBlock("br", _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.listing._source.is_special)
            ? (_openBlock(), _createElementBlock("small", _hoisted_8, [
                _createElementVNode("span", null, [
                  _createTextVNode("On special - R " + _toDisplayString(_ctx.listing._source.special_price), 1),
                  _hoisted_9,
                  _createTextVNode("From " + _toDisplayString(_ctx.formatDate(_ctx.listing._source.special_from_date)) + " to " + _toDisplayString(_ctx.formatDate(_ctx.listing._source.special_to_date)) + ")", 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.listing._source.x_last_maintenance)
            ? (_openBlock(), _createElementBlock("br", _hoisted_10))
            : _createCommentVNode("", true),
          (_ctx.listing._source.x_last_maintenance)
            ? (_openBlock(), _createElementBlock("small", _hoisted_11, " Last Maintenance: " + _toDisplayString(_ctx.formatDate(_ctx.listing._source.x_last_maintenance)), 1))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.listing._source.sku)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: 'CatalogDetails', params : { id: _ctx.listing._source.sku } }
          }, {
            default: _withCtx(() => [
              _createElementVNode("strong", {
                class: _normalizeClass({ 'has-text-white': _ctx.isDark })
              }, [
                _createElementVNode("button", {
                  class: _normalizeClass(["button is-light is-small", { 'is-primary': _ctx.isDark, 'is-info': !_ctx.isDark}])
                }, " Details ", 2)
              ], 2)
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}